'use client';

import * as TabsPrimitive from '@radix-ui/react-tabs';
import { styledList, styledTrigger } from './tabs.css';

export const Tabs = TabsPrimitive.Root;
export const TabsListBuild = TabsPrimitive.List;
export const TabsTriggerBuild = TabsPrimitive.Trigger;
export const TabsContent = TabsPrimitive.Content;
export type TabsProps = TabsPrimitive.TabsProps;

export const TabsList = (props: TabsPrimitive.TabsListProps) => {
  return <TabsPrimitive.List className={styledList} {...props} />;
};

export const TabsTrigger = (props: TabsPrimitive.TabsTriggerProps) => {
  return <TabsPrimitive.Trigger className={styledTrigger} {...props} />;
};
